import React, {Component} from 'react';

import ToggleInput from "../../../../components/ToggleInput/toggleInput";

export default class TerminalView extends Component {

    render() {

        let island = this.props.item;
        if(!island){return <div />}

        return (
            <div className={"admin-modal"}>
                <div className={"row"}>
                    <h3 className={"center"}>{island.name}</h3>
                </div>
                <div className={"row thin-row"}>
                    <div className={"col s12 input-field"}>
                        <label className="active">Código</label>
                        <p className={"field-p"}>{island.code}</p>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col s12 input-field"}>
                        <label className="active">Terminal</label>
                        <p className={"field-p"}>{island.terminal.name}</p>
                    </div>
                    <div className={"col s12 input-field"}>
                        <ToggleInput
                            selected={island.active}
                            name={'¿Isla de Descarga activa?'} />
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col s12 center"}>
                        <button
                            className={"btn btn-shell-empty z-depth-0"}
                            onClick={this.props.closeAction}
                        >Cancelar</button>
                        <button
                            className={"btn btn-shell z-depth-0"}
                            onClick={() => this.props.editAction(island, 'edit')}
                        >Editar</button>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Admin/Modals/IslandView.js